export default __webpack_public_path__ + "static/fhe_2-0e92998855a94b06603c91a0425c31db.webp";